import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import SpendComparisonCard from './SpendComparisonCard';
import BudgetPacingCard from './BudgetPacingCard';
import SpendPerDayCard from './SpendPerDayCard';
import TopOverageCard from '../TopOverageCard';

const MetricsPanel = ({ transactionData, previousTransactionData, budgets, selectedMonth, selectedYear, categoryMap }) => {
  const [metrics, setMetrics] = useState({
    budgetPacing: 0,
    spendPerDay: 0,
    budgetedSpendPerDay: 0,
    topOverage: { name: 'No Overages!', amount: 0 },
  });

  useEffect(() => {
    const currentSpend = transactionData.reduce((sum, t) => sum + t.amount, 0);

    const totalBudget = budgets.reduce((sum, b) => sum + b.categoryBudget, 0);
    let budgetPacing = 0;
    let budgetedSpendPerDay = 0;
    if (totalBudget > 0) {
      const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
      const dayOfMonth = new Date().getDate();
      const idealSpend = (totalBudget / daysInMonth) * dayOfMonth;
      budgetPacing = ((currentSpend - idealSpend) / idealSpend) * 100;
      budgetedSpendPerDay = totalBudget / daysInMonth;
    }

    const daysSoFar = new Date().getDate();
    const spendPerDay = currentSpend / daysSoFar;

    let topOverage = { name: 'No Overages!', amount: 0 };
    if (transactionData.length > 0 && budgets.length > 0) {
      const overages = budgets.map(budget => {
        const spend = transactionData
          .filter(t => t.category === budget.categoryId)
          .reduce((sum, t) => sum + t.amount, 0);
        return {
          name: categoryMap[budget.categoryId]?.category || 'N/A',
          overage: spend - budget.categoryBudget,
        };
      }).filter(o => o.overage > 0);

      if (overages.length > 0) {
        const top = overages.reduce((a, b) => (a.overage > b.overage ? a : b));
        topOverage = { name: top.name, amount: top.overage };
      }
    }

    setMetrics({
      budgetPacing,
      spendPerDay,
      budgetedSpendPerDay,
      topOverage,
    });
  }, [transactionData, previousTransactionData, budgets, selectedMonth, selectedYear, categoryMap]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <SpendComparisonCard
          currentMonthTransactions={transactionData}
          previousMonthTransactions={previousTransactionData}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <BudgetPacingCard budgetPacing={metrics.budgetPacing} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <SpendPerDayCard
          spendPerDay={metrics.spendPerDay}
          budgetedSpendPerDay={metrics.budgetedSpendPerDay}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 3 }}>
        <TopOverageCard
          name={metrics.topOverage.name}
          amount={metrics.topOverage.amount}
        />
      </Grid>
    </Grid>
  );
};

export default MetricsPanel;